import React from 'react'
import {
  Switch,
  Route,
} from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { ToastContainer, toast } from 'react-toastify'
import CloseIcon from '@material-ui/icons/Close'
import { amber, green } from '@material-ui/core/colors'

import { store } from '../store'
import FormsContainer from './Forms/Forms.container'
import DashboardContainer from './Dashboard/Dashboard.container'
import { LOGOUT } from '../actions'
import { BaseContext } from './theme.context'
import FormDetailContainer from './Forms/FormDetail.container'
import FormListContainer from './Forms/FormList.container'
import PointsContainer from './Points/Points.container'
import Drawer from './Drawer/Drawer.container'
import WidgetsContainer from './Widgets/Widgets.container'

const drawerWidth = 300

const useStyle = openDrawer => makeStyles(theme => ({
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    paddingTop: 64,
    overflowY: 'auto',
    display: 'flex',
  },
  containerContent: {
    flex: 1,
    display: 'grid',
  },
  navbar: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: `calc(100% - ${theme.spacing(7) + 1}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${!openDrawer
        ? theme.spacing(7) + 1
        : drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.down('xs')]: {
      width: `calc(100% - ${theme.spacing(7) + 1}px)`,
    },
    height: 64,
    boxShadow: 'none',
    '& .MuiToolbar-root': {
      height: '100%',
    },
  },
  buttonLeft: {
    marginRight: theme.spacing(2),
    color: '#5f6368',
  },
  button: {
    marginRight: theme.spacing(2),
    color: '#5f6368',
    position: 'absolute',
    right: 0,
  },
  title: { flexGrow: 1, color: '#5f6368' },
  icon: { fontSize: 20 },
  buttonNotification: {
    width: 48,
    height: 48,
  },
  toastNotification: {
    '& .Toastify__toast': {
      boxShadow: `
        0px 3px 5px -1px rgba(0,0,0,0.2),
        0px 6px 10px 0px rgba(0,0,0,0.14),
        0px 1px 18px 0px rgba(0,0,0,0.12)
      `,
      borderRadius: 4,
    },
    '& .Toastify__toast--success': {
      backgroundColor: green[600],
    },
    '& .Toastify__toast--error': {
      backgroundColor: theme.palette.error.dark,
    },
    '& .Toastify__toast--info': {
      backgroundColor: theme.palette.primary.main,
    },
    '& .Toastify__toast--warning': {
      backgroundColor: amber[700],
    },
  },
}))

export default () => {
  const [openDrawer, handleDrawer] = React.useState(true)
  const [background, setBackground] = React.useState('#f5f5f5')
  const [leftButton, setleftButton] = React.useState({
    show: false,
    element: null,
    onClick: () => { },
  })
  const classes = useStyle(openDrawer)()
  const logout = () => store.dispatch(LOGOUT())
  const onChangeColor = color => setBackground(color || '#f5f5f5')
  const onChangeleftButton = (show, element, onClick) => setleftButton({ show, element, onClick })

  return (
    <BaseContext.Provider value={{
      color: background,
      onChangeColor,
      onChangeleftButton,
    }}
    >
      <div
        className={classes.container}
        style={{ background }}
      >
        <Drawer
          openDrawer={openDrawer}
          handleDrawer={handleDrawer}
          drawerWidth={drawerWidth}
        />
        <div className={classes.containerContent}>
          <AppBar className={classes.navbar}>
            <Toolbar position='static'>
              {leftButton.show
                ? leftButton.element
                  ? leftButton.element
                  : (
                    <IconButton
                      edge='start'
                      color='inherit'
                      aria-label='back'
                      onClick={leftButton.onClick}
                      className={classes.buttonLeft}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  )
                : null}
              <IconButton
                edge='end'
                color='inherit'
                aria-label='logout'
                onClick={logout}
                className={classes.button}
              >
                <ExitToAppIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Switch>
            <Route exact path='/dashboard' component={DashboardContainer} />
            <Route exact path='/dashboard/forms/new' component={FormsContainer} />
            <Route path='/dashboard/forms/new/detail/:id' component={FormDetailContainer} />
            <Route exact path='/dashboard/forms/:type' component={FormListContainer} />
            <Route path='/dashboard/forms/:type/detail/:id' component={FormDetailContainer} />
            <Route path='/dashboard/points' component={PointsContainer} />
            <Route path='/dashboard/metrics' component={WidgetsContainer} />
          </Switch>
        </div>
        <ToastContainer
          className={classes.toastNotification}
          autoClose={10000}
          position={toast.POSITION.TOP_RIGHT}
          closeButton={(
            <IconButton
              key='close'
              aria-label='close'
              color='inherit'
              className={classes.buttonNotification}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>
          )}
        />
      </div>
    </BaseContext.Provider>
  )
}
